export const ENTRY_VERIFICATION_HOSTNAME = "app.refanno.com";
export const ENTRY_VERIFICATION_ENDPOINT = "/api/entry-verify";

export function isEntryVerificationHost(hostname) {
  return String(hostname || "").trim().toLowerCase() === ENTRY_VERIFICATION_HOSTNAME;
}

export function isEntryVerificationEnabled(value = process.env.REACT_APP_ENTRY_VERIFICATION_ENABLED) {
  return String(value || "").trim().toLowerCase() === "true";
}

export function buildEntryLocationTarget(location) {
  return `${location?.pathname || "/"}${location?.search || ""}${location?.hash || ""}`;
}

async function readJsonResponse(response, fallback) {
  const contentType = String(response.headers?.get?.("content-type") || "")
    .split(";", 1)[0]
    .trim()
    .toLowerCase();
  if (contentType !== "application/json") {
    const error = new Error(fallback);
    error.code = "entry_verification_invalid_content_type";
    error.status = response.status;
    throw error;
  }

  try {
    const body = await response.json();
    if (!body || typeof body !== "object" || Array.isArray(body)) {
      throw new Error("invalid_json_schema");
    }
    return body;
  } catch (_error) {
    const error = new Error(fallback);
    error.code = "entry_verification_invalid_json";
    error.status = response.status;
    throw error;
  }
}

export async function fetchEntryVerificationStatus(fetchImpl = fetch) {
  const response = await fetchImpl(ENTRY_VERIFICATION_ENDPOINT, {
    method: "GET",
    credentials: "same-origin",
    cache: "no-store",
    headers: { accept: "application/json" },
  });
  const body = await readJsonResponse(response, "entry_verification_unavailable");
  if (response.ok && body.verified === true) return true;
  if ((response.status === 401 || response.status === 403) && body.verified === false) {
    return false;
  }
  const error = new Error(String(body.error || "entry_verification_unavailable"));
  error.status = response.status;
  throw error;
}

export async function verifyEntryToken(token, fetchImpl = fetch) {
  const normalized = String(token || "").trim();
  if (!normalized) throw new Error("entry_verification_token_required");
  const response = await fetchImpl(ENTRY_VERIFICATION_ENDPOINT, {
    method: "POST",
    credentials: "same-origin",
    cache: "no-store",
    headers: {
      accept: "application/json",
      "content-type": "application/json",
    },
    body: JSON.stringify({ token: normalized }),
  });
  const body = await readJsonResponse(response, "verification_failed");
  if (response.ok && body.verified === true) return true;
  const error = new Error(String(body.error || "verification_failed"));
  error.status = response.status;
  throw error;
}
